// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__35-48","selects":"Documents_selects__Z0NQR"};